// src/pages/MaestroConsecutivos.jsx

import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { obtenerConsecutivos, guardarConsecutivo, eliminarConsecutivo, obtenerDetalleConsecutivo } from '../service/apiMaestroConsecutivos';
import SeleccionFormulariosNew from '../components/SeleccionFormulariosNew';
import SeleccionUsuarioConsecutivos from '../components/SeleccionUsuarioConsecutivos';
import SeleccionConsecutivos from '../components/SeleccionConsecutivos';
const MaestroConsecutivos = () => {
  let emptyProduct = {
    id: 0,
    codigo: '',
    nid_propietario: '',
    numero: '',
    estado: '',
    fecha_uso: ''
  };
  const [productDialog, setProductDialog] = useState(false);
  const [product, setProduct] = useState(emptyProduct);
  const [productos, setProductos] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [reload, setReload] = useState(true);
  const [enviar, setEnviar] = useState(false);
  const toastRef = useRef(null);
  const dt = useRef(null);

  const hideDialog = () => {
    setSubmitted(false);
    setProductDialog(false);
  };

  const openNew = () => {
    setProduct(emptyProduct);
    setSubmitted(false);
    setProductDialog(true);
    setEnviar(true);
  };

  useEffect(() => {
    if (reload) {
      setReload(false);
      obtenerConsecutivos().then((data) => {
        if (Array.isArray(data)) setProductos(data);
      });
    }
  }, [reload]);

  const handleGuardar = async () => {
    setSubmitted(true);
    //if (!product.codigo || !product.nid_propietario || !product.numero || !product.estado) return;
    const resultado = await guardarConsecutivo(product,toastRef, enviar);
    if (resultado === 1) {
      toastRef.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro guardado correctamente ✅', life: 3000 });
      hideDialog();
      setReload(true);
    } else if (resultado === 100) {
      toastRef.current.show({ severity: 'error', summary: 'Duplicado', detail: 'El consecutivo ya existe ❌', life: 3000 });
    } else {
      toastRef.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar ❌', life: 3000 });
    }
  };

  const handleModificar = async (rowData) => {
    const resultado = await obtenerDetalleConsecutivo(rowData.nid_propietario, rowData.numero, rowData.codigo);
    if (Array.isArray(resultado) && resultado.length > 0) {
      setProduct(resultado[0]);
      setProductDialog(true);
      setEnviar(false);
    }
  };

  const handleEliminar = (rowData) => {
    toastRef.current.show({
      severity: 'warn',
      summary: '¿Eliminar?',
      detail: (
        <div>
          <p>Consecutivo: <strong>{rowData.numero}</strong></p>
          <div className="flex gap-2 mt-2">
            <Button label="Eliminar" icon="pi pi-trash" className="p-button-danger p-button-sm"
              onClick={async () => {
                toastRef.current.clear();
                const resultado = await eliminarConsecutivo(rowData.id, rowData.numero);
                if (resultado === 1) {
                  toastRef.current.show({ severity: 'success', summary: 'Eliminado ✅', life: 3000 });
                  setReload(true);
                } else {
                  toastRef.current.show({ severity: 'error', summary: 'Error ❌', detail: 'No se eliminó', life: 3000 });
                }
              }}
            />
            <Button label="Cancelar" icon="pi pi-times" className="p-button-secondary p-button-sm"
              onClick={() => toastRef.current.clear()} />
          </div>
        </div>
      ),
      sticky: true
    });
  };

  const productDialogFooter = (
    <>
      <Button label='Cancelar' icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
      <Button label="Guardar" icon="pi pi-check" className="p-button-text" onClick={handleGuardar} />
    </>
  );

  const actionBodyTemplate = (rowData) => {
  if (parseInt(rowData.estado) === 0) {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-info mr-2"
          onClick={() => handleModificar(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={() => handleEliminar(rowData)}
        />
      </>
    );
  }

  return null; // o puedes retornar otro botón o mensaje si lo deseas
};


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || '';
    setProduct({ ...product, [name]: val });
  };

  const header = (
    <div className="table-header">
      <h5 className="mb-0">Consulta General - Gestión de Consecutivos</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
      </span>
    </div>
  );

  return (
    <div className="p-4">
      <Toast ref={toastRef} position="top-right" />
      <Button label="Nuevo Consecutivo" icon="pi pi-plus" onClick={openNew} className="mb-3" />

      <DataTable
        ref={dt}
        value={productos}
        selection={selectedProducts}
        onSelectionChange={(e) => setSelectedProducts(e.value)}
        dataKey="id"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        className="datatable-responsive"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        globalFilter={globalFilter}
        emptyMessage="No existen registros."
        header={header}
        responsiveLayout="scroll"
      >
        <Column body={actionBodyTemplate} header="Acciones" style={{ width: '150px' }} />
        <Column field="NOMBRE" header="PROPIETARIO" sortable />
        <Column field="descripcion" header="FORMULARIO" sortable />
        <Column field="numero" header="NUMERO" sortable />
        <Column field="MESTAOO" header="ESTADO" sortable />
        <Column field="fecha_uso" header="FECHA DE USO" sortable />
      </DataTable>

      <Dialog visible={productDialog} style={{ width: '600px' }} header={`Formulario Consecutivo - ${enviar ? 'Adicionando' : 'Modificando'}`} modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
        <div className="formgrid grid">
          <div className="field col">
            <label>Formulario</label>
            <SeleccionFormulariosNew handleplanta={(dato) => setProduct({ ...product, codigo: dato })} />

            <label>Propietario</label>
            <SeleccionUsuarioConsecutivos handleplanta={(dato) => setProduct({ ...product, nid_propietario: dato })} />

            <label>Consecutivo</label>
            <InputText
            value={product.numero}
            onChange={(e) => onInputChange(e, 'numero')}
            readOnly={!enviar} // solo lectura si estás en modo edición
            />

            <label>Estado</label>
            <SeleccionConsecutivos handleplanta={(dato) => setProduct({ ...product, estado: dato })} />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MaestroConsecutivos;